
































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import { default as TinyMCE } from '@tinymce/tinymce-vue'
import { State } from 'vuex-class'
import UploadManager from '@/modules/media/components/UploadManager.vue'
import FileSelector from '@/modules/media/components/FileSelector.vue'
import { MediaObject } from '@/modules/media/types'
import {Events} from 'tinymce';
import CommandEvent = Events.CommandEvent;
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {Colors, notify} from '@/modules/core/notification';
/**
 * Editor de texto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        TinyMCE,
        'upload-manager': UploadManager,
        'file-selector': FileSelector,
    },
})
export default class Editor extends Vue {
    public $refs: {
        tinyMCE: TinyMCE,
    }

    @State('darkMode')
    public darkMode: boolean

    /**
     * Placeholder
     *
     * Texto mostrado en la caja del editor cuando no se ha escrito nada
     *
     * @type { string }
     */
    @Prop({required: false, type: String, default: 'Inserta aqui tu contenido'})
    public placeholder: string

    /**
     * Contenido mostrado en el editor
     *
     * @type { string }
     */
    @Prop({required: true, type: String})
    public value: string

    public setFileCallback: (file: string, metadata?: object) => void
    public fileSelector = false
    public ready = false

    /**
     * Indica si el editor se encuentra en modo "solo lectura" en el cual el
     * usuario no puede editar el contenido
     */
    @Prop({type: Boolean, default: false})
    public readonly: boolean

    /**
     * Indica el alto del editor
     */
    @Prop({type: String, default: '400px'})
    public height: string

    /**
     * Permite especificar un texto que será mostrado encima del editor como la
     * etiqueta de un text field
     */
    @Prop({type: String, default: ''})
    public label: string

    /**
     * Especifica la elevación de la sombra de material design que tendrá
     * el contenedor del editor
     */
    @Prop({type: [String, Number], default: 0})
    public elevation: number

    @Prop({type: Boolean, default: true})
    public loadPlaceholder: boolean

    public insertingPDF = false
    public insertingMedia = false
    public fileSelectorValidTypes: string[] = []
    public modalObserver: MutationObserver | null = null

    /**
     * Observa la propiedad readonly para cambiar el modo de edición
     * del editor
     */
    @Watch('readonly')
    public watchReadonly (readonly: boolean) {
        this.$refs.tinyMCE.editor.setMode(readonly ? 'readonly' : 'design')
    }

    public mounted () {
        // tslint:disable-next-line:radix
        // this.height = `${parseInt(this.height)} px`
        if (document.getElementsByClassName('mce-tinymce').length > 0) {
            this.ready = true
        }
    }

    /**
     * Controla la visibilidad del modal para la selección de ficheros
     */
    public toggleFileSelector (show: boolean) {
        this.fileSelector = show

        if (!show && this.insertingPDF) {
            this.insertingPDF = false
        }

        const display = show ? 'none' : 'flex'
        const dialog = document.getElementsByClassName('tox-dialog-wrap')[0] as HTMLDivElement
        const toolbar = document.getElementsByClassName('tox-toolbar__overflow')[0] as HTMLDivElement
        dialog && (dialog.style.display = display)
        toolbar && (toolbar.style.display = display)
    }

    /**
     * Observa el DOM y emite un evento cuando el editor TinyMCE muestra un modal o
     * dialogo en pantalla
     */
    public watchEditorModal () {
        const search = document.getElementsByClassName('tox-tinymce-aux')
        // El elemento que contiene los diálogos no puede ser encontrado por su
        // nombre de clase
        if (!search.length) {
            return
        }

        const auxiliarContainer = search[0] as HTMLDivElement
        auxiliarContainer.onmouseenter = () => this.$emit('mouseenter')
        auxiliarContainer.onmouseleave = () => this.$emit('mouseleave')

        const notify = (mutation: MutationRecord, type: 'removedNodes' | 'addedNodes') => {
            mutation[type].forEach(node => {
                if (node.nodeName !== 'DIV') {
                    return
                }

                (node as HTMLDivElement).classList.contains('tox-dialog-wrap')
                && this.$emit('editorDialog', type !== 'removedNodes')
            })
        }

        const observer = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach(mutation => {
                // Mutaciones en el DOM de otro tipo que no sean modificaciones del árbol
                // serán obviadas
                if (mutation.type !== 'childList') {
                    return
                }

                notify(mutation, 'removedNodes')
                notify(mutation, 'addedNodes')
            })
        })


        observer.observe(auxiliarContainer, {
            childList: true,
        })

        this.modalObserver = observer
    }

    /**
     * Opciones del editor
     */
    get options () {
        return {
            skin: this.darkMode ? 'oxide-dark' : null,
            content_css: this.darkMode ? 'dark' : null,
            toolbar_mode: 'sliding',
            branding: false,
            setup: (editor: any) => {
                editor.on('init', () => {
                    this.ready = true
                    this.watchEditorModal()
                })

                editor.setMode(this.readonly ? 'readonly' : 'design')
                // Cada comando ejecutado por el editor TinyMCE es emitido como un evento
                // al componente padre
                editor.on('ExecCommand', (command: CommandEvent) => this.$emit('execCommand', command))

                editor.ui.registry.addIcon('pdf', `
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M10.92,12.31C10.68,11.54 10.15,9.08 11.55,9.04C12.95,9 12.03,12.16 12.03,12.16C12.42,13.65 14.05,14.72 14.05,14.72C14.55,14.57 17.4,14.24 17,15.72C16.57,17.2 13.5,15.81 13.5,15.81C11.55,15.95 10.09,16.47 10.09,16.47C8.96,18.58 7.64,19.5 7.1,18.61C6.43,17.5 9.23,16.07 9.23,16.07C10.68,13.72 10.9,12.35 10.92,12.31M11.57,13.15C11.17,14.45 10.37,15.84 10.37,15.84C11.22,15.5 13.08,15.11 13.08,15.11C11.94,14.11 11.59,13.16 11.57,13.15M14.71,15.32C14.71,15.32 16.46,15.97 16.5,15.71C16.57,15.44 15.17,15.2 14.71,15.32M9.05,16.81C8.28,17.11 7.54,18.39 7.72,18.39C7.9,18.4 8.63,17.79 9.05,16.81M11.57,11.26C11.57,11.21 12,9.58 11.57,9.53C11.27,9.5 11.56,11.22 11.57,11.26Z" />
                    </svg>
                `)

                editor.ui.registry.addIcon('material-video', `
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
                    </svg>
                `)

                // Registra un botón con el cual el usuario puede insertar archivos
                // PDF seleccionándolos directamente desde la librería multimedia
                editor.ui.registry.addButton('pdf', {
                    icon: 'pdf',
                    tooltip: 'Inserta un PDF de la librería multimedia',
                    onAction: () => {
                        this.insertingPDF = true
                        this.fileSelectorValidTypes = ['application/pdf']
                        this.toggleFileSelector(true)
                    },
                })

                editor.ui.registry.addButton('prologueMedia', {
                    icon: 'material-video',
                    tooltip: 'Inserta un video de la librería multimedia',
                    onAction: () => {
                        this.insertingMedia = true
                        this.fileSelectorValidTypes = ['video']
                        this.toggleFileSelector(true)
                    },
                })
            },
            mobile: {
                theme: 'mobile',
            },
            resize: false,
            height: this.height,
            language_url: this.translationURL,
            language: 'es',
            // Lista de plugins habilitados
            plugins: 'print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount  imagetools textpattern help linkchecker code',
            toolbar: 'undo redo | fontselect | fontsizeselect | formatselect | bold italic strikethrough forecolor backcolor permanentpen formatpainter | link image media prologueMedia pdf| alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent | removeformat | addcomment',
            image_advtab: true,
            relative_urls: false,
            file_browser_callback_types: ['image'],
            file_picker_callback: (callback: (file: string) => void, value: any, meta: any) => {
                this.fileSelectorValidTypes = []
                this.toggleFileSelector(true)
                this.setFileCallback = callback
            },
            style_formats: [
                {
                    title: 'Espaciado derecho',
                    selector: 'img',
                    styles: {
                        margin: '0 10px 10px 0',
                    },
                },
            ],
        }
    }

    /**
     * Url del archivo para la traducción del editor
     */
    get translationURL (): string {
        return localStorage.getItem('config.tinymce.translationURL')
        || (process.env.NODE_ENV === 'production' ? process.env.BASE_URL : '') + `tinymce/translation/es.js`
    }

    /**
     * Inserta contenido HTML en la posición actual del cursos
     * del editor
     */
    public insert (content: string, args: KeyValuePair = {}) {
        const tinyMCE = this.$refs.tinyMCE
        // El editor no se encuentra disponible
        if (!tinyMCE) {
            return
        }

        tinyMCE.editor.insertContent(content, args)
    }

    /**
     * Evento llamado cuando el selector de ficheros lanza un evento indicando
     * que se el usuario ha selecciona un evento
     */
    public onSelect (media: MediaObject) {
        switch (true) {
            // El editor se encuentra insertando un video en el editor
            case this.insertingMedia:
                this.insert(`<video src="${media.url}"></video>`)
                this.insertingMedia = false
                break
            // El editor se encuentra insertando un archivo PDF
            case this.insertingPDF:
                const iframe = document.createElement('iframe')
                iframe.src = media.url
                this.insert(iframe.outerHTML)
                this.insertingPDF = false
                break
            // Por defecto cualquier archivo multimedia seleccionado por el usuario
            // será enviado al editor para que este lo coloque
            case !!this.setFileCallback:
                this.setFileCallback(media.url, { alt: media.title || ''})
                break
            default:
                notify(`No se ha podido insertar el fichero ${media.originalName}`, Colors.Warning)
        }

        this.toggleFileSelector(false)
        this.fileSelectorValidTypes = []
    }

    /**
     * Elimina la referencia al observador de mutaciones encargado de emitir
     * eventos cuando un modal del editor TinyMCE aparece en pantalla
     */
    public destroyed () {
        if (this.modalObserver) {
            this.modalObserver.disconnect();
            this.modalObserver = null
        }
    }
}
